import client from '../client';
import config from '../config';
import { showLoading, hideLoading } from 'react-redux-loading-bar';

export const getFilterData = (payload) => {
    return (dispatch) => {
        return client().post(`${config.authAPI}/filters/getfilterdata`, payload);
    }
}